import { createClient } from "@/app/utils/supabase/client";
import type { PostCategoryT } from "@/app/types/posts";

export async function getAllPostCategories(): Promise<PostCategoryT[] | null> {
  const supabase = createClient();

  const { data, error } = await supabase
    .from("post_categories")
    .select(
      `
      id,
      created_at,
      updated_at,
      label,
      key,
      slug
    `
    )
    .order("label");

  if (error) {
    console.error("Fehler beim Abrufen der Post-Kategorien:", error);
    return null;
  }

  if (!data) return [];

  return data as PostCategoryT[];
}
